import apiFinance from '@/api/finance'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  createFinanceStart: '[create finance] Create finance start',
  createFinanceSuccess: '[create finance] Create finance success',
  createFinanceFailure: '[create finance] Create finance failure',
}

export const actionTypes = {
  createFinance: '[create finance] Create finance',
}

const mutations = {
  [mutationTypes.createFinanceStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.createFinanceSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.createFinanceFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.createFinance](context, finance) {
    context.commit(mutationTypes.createFinanceStart)
    return new Promise((resolve) => {
      apiFinance
        .createFinance(finance)
        .then((res) => {
          context.commit(mutationTypes.createFinanceSuccess)
          resolve(res.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.createFinanceFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
